module.exports = __webpack_public_path__ + "media/video-d.2c98fda8.mp4";